/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./reset-color.vue?vue&type=template&id=53b4881e&"
import script from "./reset-color.vue?vue&type=script&lang=ts&"
export * from "./reset-color.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports